/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { TranslocoModule } from '@jsverse/transloco';

import { faTrashAltIcon } from 'IconLibrary/fontawesome/regular/trash-alt';
import { faQuestionCircleIcon } from 'IconLibrary/fontawesome/regular/question-circle';
import { bulbCollectionIcon } from 'IconLibrary/bulb/collection';
import { faCloneIcon } from 'IconLibrary/fontawesome/regular/clone';
import { faEllipsisHIcon } from 'IconLibrary/fontawesome/regular/ellipsis-h';
import { fasDoNotEnterIcon } from 'IconLibrary/fontawesome/solid/do-not-enter';
import { fasDoorOpenIcon } from 'IconLibrary/fontawesome/solid/door-open';
import { faFileIcon } from 'IconLibrary/fontawesome/regular/file';
import { faFlagIcon } from 'IconLibrary/fontawesome/regular/flag';
import { faDesktopIcon } from 'IconLibrary/fontawesome/regular/desktop';
import { faHeartIcon } from 'IconLibrary/fontawesome/regular/heart';
import { fasHeartIcon } from 'IconLibrary/fontawesome/solid/heart';
import { faSparklesIcon } from 'IconLibrary/fontawesome/regular/sparkles';
import { faSyncIcon } from 'IconLibrary/fontawesome/regular/sync';

import { provideSvgIcons, SvgIconComponent } from '@ngneat/svg-icon';
import { AeroModule } from '../../aero/aero.module';
import { SVGIconModule } from '../svg-icon/svg-icon.module';
import { MenusModule } from '../menus/menus.module';

import { CompositeViewMenusComponent } from './composite-view-menus/composite-view-menus.component';
import { SharePanelModule } from '../share-panel/share-panel.module';
import { TelemetryModule } from '../telemetry/telemetry.module';
import { SubmitAssignmentModule } from '../submit-assignment/submit-assignment.module';

(fasHeartIcon as any).name = 'heart-solid';

@NgModule({
  declarations: [
    CompositeViewMenusComponent,
  ],
  imports: [
    CommonModule,
    AeroModule,
    ButtonModule,
    MenusModule,
    SharePanelModule,
    TelemetryModule,
    TranslocoModule,
    SVGIconModule,
    SvgIconComponent,
    SubmitAssignmentModule,
  ],
  exports: [
    CompositeViewMenusComponent,
  ],
  providers: [
    provideSvgIcons([
      bulbCollectionIcon,
      faCloneIcon,
      faDesktopIcon,
      fasDoNotEnterIcon,
      fasDoorOpenIcon,
      faEllipsisHIcon,
      faFileIcon,
      faFlagIcon,
      faHeartIcon,
      fasHeartIcon,
      faSparklesIcon,
      faSyncIcon,
      faTrashAltIcon,
      faQuestionCircleIcon,
    ]),
  ],
})
export class CompositeViewModule { }
